import { FC } from "react";
import { ListboxOption, ListboxOptions } from "@headlessui/react";
import { Check } from "lucide-react";

import { CompaniesItems, SuccinctSite } from "@vviinn/user-managment-client-ts";

import { mergeClassNames } from "../../helpers";
import { MEDIUM_ICON_SIZE_STYLES } from "../styles";

type ListBoxProps = {
  listItems: CompaniesItems[] | SuccinctSite[];
};

const listEntryTitle = (item: CompaniesItems | SuccinctSite) => {
  if ("name" in item) return item.name;
  else if ("domain" in item) return item.domain;
  return "";
};

export const ListboxDropdown: FC<ListBoxProps> = ({ listItems }) => {
  return (
    <ListboxOptions className="absolute z-10 max-h-60 w-full overflow-auto rounded-md bg-stone-50 py-1 text-base ring-1 ring-black/5 focus:outline-none sm:text-sm right-0 mt-2 dark:bg-stone-700">
      {listItems.map((listItem) => (
        <ListboxOption
          key={listItem.id}
          className={({ focus }) =>
            mergeClassNames(
              focus
                ? "bg-stone-600 text-white"
                : "text-stone-900 dark:text-stone-300",
              "relative cursor-default select-none py-2 pl-3 pr-9",
            )
          }
          value={listItem}
        >
          {({ selected, focus }) => (
            <>
              <span
                className={mergeClassNames(
                  selected ? "font-semibold" : "font-normal",
                  "block truncate",
                )}
              >
                {listEntryTitle(listItem)}
              </span>

              {selected ? (
                <span
                  className={mergeClassNames(
                    focus ? "text-white" : "text-stone-600 dark:text-stone-400",
                    "absolute inset-y-0 right-0 flex items-center pr-4",
                  )}
                >
                  <Check className={MEDIUM_ICON_SIZE_STYLES} />
                </span>
              ) : null}
            </>
          )}
        </ListboxOption>
      ))}
    </ListboxOptions>
  );
};
